/**
 * Global UI click sound for actionable controls.
 * Opt out: data-no-click-sound on the control or an ancestor.
 * Overlay dismiss: only blurred backdrops (cart / demos) — not empty page clicks.
 */
(function () {
  'use strict';

  var SRC =
    'https://cdn.shopify.com/s/files/1/1081/4036/4062/files/bentovox-click-sound-01.mp3?v=1785989800';
  var VOL = 0.4;
  var pool = [];
  var SELECTOR = [
    'button',
    '[role="button"]',
    'summary',
    'input[type="button"]',
    'input[type="submit"]',
    'input[type="reset"]',
    'a.button',
    'label.button',
    'a.bbap-demo__cta',
    '[data-bbap-cta]',
    '.bbap-demo__cta',
    '.bbap-demo__more-card',
    '.bbap-demo__pill',
    '.bcaf-empty__btn',
    '[data-bcaf-empty-browse]',
    '[data-bbap-pick]',
    '[data-bbap-play]',
    '[data-bbap-more-play]',
    '[data-bbap-side]',
    '[data-bbap-more-side]',
    '[data-bbap-prev]',
    '[data-bbap-next]',
    '[data-bbap-more]',
    '[data-bcaf-daw]',
    '[data-bcaf-plugin]',
    '[data-bcaf-close]',
    '[data-bcaf-gift-claim]',
    '[data-bcaf-gift-continue]',
    '[data-bcaf-gift-skip]'
  ].join(',');

  function acquire() {
    var a = null;
    for (var i = 0; i < pool.length; i++) {
      if (pool[i].paused || pool[i].ended) {
        a = pool[i];
        break;
      }
    }
    if (!a) {
      a = new Audio(SRC);
      a.preload = 'auto';
      a.volume = VOL;
      pool.push(a);
      if (pool.length > 8) pool.shift();
    }
    a.volume = VOL;
    return a;
  }

  // Blurred overlay chrome that dismisses a floating layer — not blank page.
  function isDismissScrim(el) {
    if (!el || el.nodeType !== 1) return false;
    var cls = el.classList;
    if (!cls) return false;
    if (cls.contains('bbap-more__backdrop')) return true;
    if (cls.contains('cart-drawer__backdrop')) return true;
    if (cls.contains('bbap-up__backdrop')) return true;
    // Demos modal root is the blurred scrim (padding around the panel).
    if (cls.contains('bbap-more') && cls.contains('is-open')) return true;
    return false;
  }

  function shouldPlay(target) {
    if (!target || target.nodeType !== 1) return false;
    if (target.closest('[data-no-click-sound]')) return false;
    if (isDismissScrim(target)) return true;
    var ctrl = target.closest(SELECTOR);
    if (!ctrl) return false;
    if (ctrl.disabled || ctrl.getAttribute('aria-disabled') === 'true') return false;
    if (ctrl.closest('[disabled], [aria-disabled="true"]')) return false;
    return true;
  }

  function play() {
    try {
      var a = acquire();
      a.currentTime = 0;
      var p = a.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } catch (e) {}
  }

  var warmed = false;
  document.addEventListener(
    'pointerdown',
    function (e) {
      if (e.button != null && e.button !== 0) return;
      if (!shouldPlay(e.target)) return;
      if (!warmed) {
        warmed = true;
        try {
          acquire();
        } catch (err) {}
      }
      play();
    },
    true
  );
})();
